import React, { useState } from 'react'
import { Formik, Form } from 'formik'
import { FaCheck } from 'react-icons/fa'

import dateUtils from '~/util/date'

import Yup from '~/services/yup'

import ActionFooter from '~/components/ActionFooter'
import CreditCard from '~/components/CreditCard'
import Modal from '~/components/Modal'
import {
    Button, Textbox, Checkbox, Select
} from '~/components/Form'

import { Container, TermoContainer, ModalTermoContainer } from './styles'

const { Iugu } = window

const initialValues = {
    expiracao: '',
    numero: '',
    titular: '',
    cvv: '',
    autorizado: false
}

const validation = Yup.object({
    mes: Yup.string().ensure().required('Selecione o mês de vencimento.'),
    ano: Yup.string().ensure().required('Selecione o ano de vencimento.'),
    numero: Yup.string().creditCard().required('Digite o número do cartão.'),
    titular: Yup.string().required('Digite o nome como consta no cartão.'),
    cvv: Yup.number().typeError('Código de segurança inválido.').required('Digite o código de segurança impresso em seu cartão.'),
    autorizado: Yup.boolean()
})

export default function ({ onSubmit, valorMensalidade }) {
    const [submitting, setSubmitting] = useState(false)
    const [showTermoCiencia, setShowTermoCiencia] = useState(false)

    function handleSubmit(values, formikBag) {
        setSubmitting(true)

        const brandName = Iugu.utils.getBrandByCreditCardNumber(values.numero)

        onSubmit({
            ...values,
            brand: brandName
        }, formikBag, () => { setSubmitting(false) })
    }

    return (
        <>
            <Container>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validation}
                    onSubmit={handleSubmit}
                    enableReinitialize
                >
                    {({
                        isSubmitting, setFieldValue, values
                    }) => (
                        <Form>
                            <CreditCard
                                name={values.titular}
                                number={values.numero}
                                expiration={values.ano?.value && values.mes?.value && new Date(values.ano.value, values.mes.value - 1)}
                                cvv={values.cvv}
                            />

                            <Select
                                name="mes"
                                label="Mês de vencimento"
                                isSearchable={false}
                                containerStyle={{ gridArea: 'mes' }}
                                options={dateUtils.months}
                                onChange={selected => { setFieldValue('mes', selected) }}
                            />

                            <Select
                                name="ano"
                                label="Ano de vencimento"
                                isSearchable={false}
                                containerStyle={{ gridArea: 'ano' }}
                                options={dateUtils.futureYears}
                                onChange={selected => {
                                    setFieldValue('ano', selected)
                                }}
                            />

                            <Textbox
                                label="Número do cartão"
                                name="numero"
                                id="numero_cartao"
                                inputMode="numeric"
                                maxLength={16}
                                containerStyle={{ gridArea: 'numero' }}
                            />

                            <Textbox
                                label="Nome do titular"
                                name="titular"
                                style={{ textTransform: 'uppercase' }}
                                containerStyle={{ gridArea: 'titular' }}
                            />

                            <Textbox
                                label="CVV"
                                name="cvv"
                                maxLength={4}
                                inputMode="numeric"
                                containerStyle={{ gridArea: 'cvv' }}
                            />

                            <TermoContainer>
                                <Button onClick={() => setShowTermoCiencia(true)} className="transparent">
                                    VER TERMO DE CIÊNCIA
                                </Button>
                            </TermoContainer>

                            <Checkbox
                                name="autorizado"
                                label={`Li e concordo com o Termo de Ciência acima e autorizo o desconto da mensalidade através de débito em meu cartão de crédito, no dia ${new Date().getDate() < 10 ? `0${new Date().getDate()}` : `${new Date().getDate()}`} de cada mês, com valor correspondente a R$ ${valorMensalidade.toFixed(2).replace('.', ',')} em favor do Sindicato dos Médicos do Pará. Estou ciente que este valor será reajustado anualmente no mês de janeiro.`}
                                handleChange={e => { setFieldValue(e.target.name, e.target.checked) }}
                            />

                            <ActionFooter style={{ gridArea: 'button' }}>
                                <Button type="submit" loading={isSubmitting || submitting} className="white">
                                    Concluir
                                    <FaCheck />
                                </Button>
                            </ActionFooter>
                        </Form>
                    )}
                </Formik>
            </Container>

            <Modal
                isOpen={showTermoCiencia}
                handleClose={() => setShowTermoCiencia(false)}
                title="Termo de Ciência do Associado"
            >
                <ModalTermoContainer>
                    <iframe src={`${process.env.REACT_APP_BACKEND_URL}/resources/TERMO DE CIENCIA SINDMEPA.pdf`} frameBorder="0" title="Termo de Ciência" />
                </ModalTermoContainer>
            </Modal>
        </>
    )
}
